// 일정 색상 팔레트 — 프론트 공용.
// 저장은 hex 문자열(ev.color)로 하고, 미지정(null)이면 기본 강조색(var(--accent))으로 렌더한다.
// 라이트/다크 양쪽에서 자연스러운 8색으로 선별.
export const EVENT_COLORS = [
  { value: '#6366f1', name: '인디고' },
  { value: '#3b82f6', name: '블루' },
  { value: '#06b6d4', name: '시안' },
  { value: '#10b981', name: '그린' },
  { value: '#f59e0b', name: '앰버' },
  { value: '#f97316', name: '오렌지' },
  { value: '#ef4444', name: '레드' },
  { value: '#ec4899', name: '핑크' },
];

// 유효한 팔레트 색만 통과 (그 외/빈값은 null → 기본색)
export function normalizeColor(c) {
  if (!c) return null;
  return EVENT_COLORS.some((x) => x.value === c) ? c : null;
}

// 실제 렌더에 쓸 색 (미지정이면 CSS 변수로 폴백)
export function colorOf(ev) {
  return (ev && ev.color) || 'var(--accent)';
}
